import { render, staticRenderFns } from "./DashboardWidgetIndiceIndipendenzaTerzi.vue?vue&type=template&id=38e152d6&"
import script from "./DashboardWidgetIndiceIndipendenzaTerzi.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetIndiceIndipendenzaTerzi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports